import {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { getNextTheme, type AppTheme } from "@/constants/theme";
import {
  readInitialThemePreference,
  syncThemePreference,
} from "@/contexts/themePreference";

export interface ThemePreference {
  theme: AppTheme;
  toggleTheme: () => void;
}

export function useThemePreference(): ThemePreference {
  const [theme, setTheme] = useState<AppTheme>(readInitialThemePreference);

  useEffect(() => {
    syncThemePreference(theme);
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme(getNextTheme);
  }, []);

  return useMemo(
    () => ({ theme, toggleTheme }),
    [theme, toggleTheme],
  );
}
